import { render } from "./Wallets.vue?vue&type=template&id=a15de39c&scoped=true"
import script from "./Wallets.vue?vue&type=script&lang=js"
export * from "./Wallets.vue?vue&type=script&lang=js"

import "./Wallets.vue?vue&type=style&index=0&id=a15de39c&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a15de39c"]])

export default __exports__